<template>
  <div :key="String(includeMargins)">
    <template v-if="product.eanLabel?.status === 'available'">
      <template
        v-if="
          product.eanLabel?.availableInCountries[culture.country] ||
          (product.eanLabel?.explicitCulture?.country && product.eanLabel?.availableInCountries[product.eanLabel?.explicitCulture?.country])
        "
      >
        <p>
          {{ appTranslate('Click on a label to download as PDF') }}
          <!-- <select v-model="selectedRenderFormat">
            <option v-for="format of RenderFormats" :key="format" :value="format">{{ format.toUpperCase() }}</option>
          </select> -->
        </p>

        <PrintWarnings :availability="product.availability" />

        <div class="label-container">
          <div v-for="labelType of EanLabelTypes" :key="labelType">
            <h6 class="mb-3 w-100 text-center">
              {{ translate(labelType, 'application', undefined, 'sv') }}
              {{ getEanLabelDimensions(labelType) }}
            </h6>
            <EanLabel
              v-if="product.eanLabel.status === 'available'"
              :product="product"
              :data="product.eanLabel"
              :type="labelType"
              class="position-relative"
              :class="{
                link: !downloading.has(labelType),
                faded: downloading.has(labelType),
              }"
              :country="culture.country"
              :language="culture.language"
              show-soft-outline
              @click="download(labelType)"
            >
              <LoaderComponent v-if="downloading.has(labelType)" inner size="medium" />
            </EanLabel>
          </div>
        </div>
      </template>
      <template v-else>
        {{ appTranslate('EAN labels for this product are not available for %s', [getLocaleString(culture)]) }}
        <img :src="getFlag(culture.country)" class="small-flag" />
      </template>
    </template>
    <template v-else>
      {{ appTranslate(product.eanLabel?.reason) }}
    </template>
  </div>
</template>

<script lang="ts" setup>
import EanLabel from '@/components/export/ean/EanLabel.vue'
import LoaderComponent from '@/components/simple/LoaderComponent.vue'
import { useTools } from '@/composables/useTools'
import { useTranslation } from '@/composables/useTranslation'
import { RenderFormat, RenderFormats, EanLabelType, EanLabelTypes } from '@/models/Ean'
import { Culture } from '@/models/Global'
import { SimplifiedProduct } from '@/models/Product'
import ExportService from '@/services/ExportService'
import { getEanLabelDimensions } from '@/utils/productUtils'
import { getLocaleString } from '@/utils/tools'
import { ref } from 'vue'
import PrintWarnings from '../PrintWarnings.vue'

const props = defineProps<{ product: SimplifiedProduct; culture: Culture }>()

const { translate, appTranslate } = useTranslation()
const { getFlag } = useTools()

const downloading = ref(new Set<EanLabelType>())
const includeMargins = ref(false)
const selectedRenderFormat = ref<RenderFormat>('pdf')

const download = async (type: EanLabelType) => {
  if (!downloading.value.has(type)) {
    downloading.value.add(type)
    try {
      const dimensions = getEanLabelDimensions(type)

      await ExportService.exportEanLabels(
        new URLSearchParams({
          _field_sku: props.product.sku,
        }),
        1,
        type,
        `${props.product.sku}_${dimensions}`,
        props.culture,
        selectedRenderFormat.value,
      )
    } catch (err) {
      console.log(err)
    } finally {
      downloading.value.delete(type)
    }
  }
}
</script>

<style lang="scss" scoped>
.label-container {
  display: flex;
  flex-direction: column;
  // flex-wrap: wrap;
  // justify-content: space-around;

  > * {
    // max-width: 100%;
    width: fit-content;
    margin: 1em;
    margin-top: 2em;

    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex: 1;
  }

  .label {
    margin-top: 2em;
  }

  .faded {
    opacity: 0.5;
  }
}

// .absolute-centered {
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
// }

.settings {
  padding: 0.5em 1em;
  background-color: #eee8;
}

.warning-msg {
  color: var(--warning);
  font-size: 14px;
}
</style>
